import React from 'react';
import { Gender } from '../../pages/NewPatient';
import moment from 'moment';
import { AbhaFilled, AbhaIconNotLinked, tickIcon2 } from '../common/Icons';

const getAgeStringMoment = (date: moment.Moment) => {
    const today = moment();

    const stringArr = [];

    const years = today.diff(date, 'year');
    date.add(years, 'years');

    if (years > 0) {
        stringArr.push(`${years}y`);
    }

    const months = today.diff(date, 'months');
    date.add(months, 'months');

    if (months > 0) {
        stringArr.push(`${months}m`);
    }

    const days = today.diff(date, 'days');

    if (days > 0) {
        stringArr.push(`${days}d`);
    }

    return stringArr && stringArr.length !== 0
        ? stringArr.length === 1
            ? stringArr[0]
            : stringArr.slice(0, 2).join(', ')
        : undefined;
};

const getAgestring = (
    ageDays: string | undefined,
    ageMonth: string | undefined,
    dob:
        | {
              dd?: string;
              mm?: string;
              yyyy?: string;
          }
        | undefined,
) => {
    let date;

    if (dob) {
        date = moment(`${dob.mm}/${dob.dd}/${dob.yyyy}`, 'MM/DD/YYYY');
        return getAgeStringMoment(date);
    }

    if (ageDays) {
        date = moment().subtract(parseInt(ageDays), 'days');
    } else if (ageMonth) {
        date = moment().subtract(parseInt(ageMonth), 'months');
    } else {
        date = moment('01/01/1992', 'MM/DD/YYYY');
    }

    return getAgeStringMoment(date);
};

const AbhaCard: React.FC<{
    createSkipState: string | undefined;
    name: string | undefined;
    gender: Gender | undefined;
    ageDays: string | undefined;
    ageMonth: string | undefined;
    dob:
        | {
              dd?: string | undefined;
              mm?: string | undefined;
              yyyy?: string | undefined;
          }
        | undefined;
    phoneNumber: string | undefined;
    abhaId: string | undefined;
    className?: string;
}> = ({
    createSkipState,
    name,
    gender,
    ageDays,
    dob,
    phoneNumber,
    ageMonth,
    abhaId,
    className,
}) => {
    return (
        <div
            className={`${
                createSkipState === 'abha_queued'
                    ? 'bg-darwin-accent-bright-blue-100'
                    : 'bg-darwin-green-bg-light'
            } flex flex-col rounded-8 gap-8 p-12 items-start ${className ?? ''}`}
        >
            <div className="flex w-full flex-col justify-between gap-8">
                <div className="flex w-full flex-col gap-4">
                    <p className="text-16 font-700 text-darwin-neutral_new-1000 text-left">
                        {name ?? ''}
                        {gender && gender[0] ? ` | ${gender[0]?.toUpperCase()}` : ''}
                        {getAgestring(ageDays, ageMonth, dob)
                            ? ` | ${getAgestring(ageDays, ageMonth, dob)}`
                            : ''}
                    </p>
                    <p className="text-13 font-400 text-darwin-neutral_new-800 text-left">
                        +91 {phoneNumber ?? ''}
                    </p>
                </div>
                <div
                    className={`flex w-full bg-white py-4 px-8 rounded-8 border ${
                        createSkipState === 'abha_queued'
                            ? 'border-darwin-accent-bright-blue-800'
                            : 'border-darwin-green-primary'
                    } items-center justify-between`}
                >
                    <div className="flex items-center gap-8">
                        <span>{abhaId ? AbhaFilled() : AbhaIconNotLinked}</span>
                        <p className="text-12 font-400">{abhaId ?? ''}</p>
                    </div>
                    {createSkipState === 'abha_queued' ? (
                        <p className="text-12 font-400">Creation in progress...</p>
                    ) : (
                        <span className="border border-darwin-green-primary flex items-center justify-center rounded-full">
                            {tickIcon2('fill-darwin-green-primary font-700 w-16 h-16')}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AbhaCard;
